// extracted by mini-css-extract-plugin
export var legendIndicator = "_ck-1";
export var legendRight = "_ck-0";